import { createFileRoute } from '@tanstack/react-router'
import { taskDetailSearchSchema } from '../../../features/tasks/search'
import { TaskDetailPage } from '../../../features/tasks/task-detail-page'

export const Route = createFileRoute('/_app/tasks/$taskId')({
  staticData: { crumb: 'task' },
  validateSearch: taskDetailSearchSchema,
  component: TaskDetailPage,
})
